// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nh8_","toggleWrap":"styles_toggleWrap__2lDU1","content":"styles_content__33YO_","selectAreaCode":"styles_selectAreaCode__1xK9G"};